import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { openPopupWidget } from "react-calendly";

//@ts-ignore
import styles from './navbar.module.css'

interface INavbarProps {
    buttonData: {
        url: string;
        buttonText: string;
    }
}
const useLogoQuery = () => {
    const data = useStaticQuery(graphql`
    query LogoQuery {
        contentfulAsset(file: {fileName: {eq: "beatIcon.png"}}) {
          title
          file {
            url
            fileName
            details {
              size
              image {
                width
                height
              }
            }
          }
        }
      }
    `)
    return data?.contentfulAsset?.file?.url;
}
export const Navbar: React.FunctionComponent<INavbarProps> = (props) => {
    const logoUrl = useLogoQuery();
    const linkRef = useRef();
    const [menuOpen, setMenuOpen] = useState(false);
    const {buttonData} = props

    const [isMobile, setIsMobile] = useState(false);
    const onResize = () => {
        const _isMobile = window.innerWidth < 768;
        setIsMobile(_isMobile);
    }
    useEffect(() => {
        onResize();
        window.onresize = onResize;
    }, [])

    const openCalendly = () => {
        openPopupWidget({url: buttonData?.url})
    }
    return(
        <>
        <nav className={styles.navbar} >
            <a href="https://salesbeat.co">
                <img src={logoUrl}></img>
            </a>
            <div ref={linkRef} className={styles.links } 
                style={{display: (isMobile) ? (menuOpen ? "flex" : "none") : "flex"}}
            >
                <ul className={styles.linkUl}>
                    <li onClick={() => {
                        setMenuOpen(!menuOpen);
                        scrollTo('#page_section_0');
                    }}><a >Product</a></li>
                    <li onClick={() => {
                        setMenuOpen(!menuOpen); 
                        scrollTo('#pricing_section')
                    }}><a >Pricing</a></li>
                    <li onClick={() => {
                        setMenuOpen(!menuOpen); 
                        scrollTo('#academy')
                    }}><a >Academy</a></li>
                    <li onClick={() => {
                        setMenuOpen(!menuOpen); 
                        scrollTo('#about_us')
                    }}><a>Awards</a></li>
                </ul>
                <div className={styles.demoButton} onClick={openCalendly}>
                    {/* <a href={buttonData?.url} target="_blank">{buttonData?.buttonText}</a> */}
                    <div>{buttonData?.buttonText}</div>
                </div>
            </div>

            <a href="javascript:void(0);" className={styles.icon} onClick={() => {
                // linkRef?.current?.classList?.toggle('onscreen');
                setMenuOpen(!menuOpen);
                // console.log("clicked!", linkRef?.current?.classList, {menuOpen})
            }}>
                    <i className="fa fa-bars"></i></a> 
            
        </nav>
       </>
    )
}
